const homeDe = {
	hero: {
		title: 'Willkommen bei Grameen Bazar',
		subtitle: 'Finden Sie, was Sie brauchen',
	},
	search: {
		placeholderDefault: 'Produkte suchen...',
		typewriterPlaceholders: ['Chachkoir Bazar', 'Kaufladen', 'Alim Store', 'Malabarspinat'],
	},
	partners: {
		heading: 'Unsere Partner',
		subheading: 'Zusammenarbeit mit vertrauenswürdigen Organisationen',
	},
};

export default homeDe;


